import { DefaultService } from '@/services/DefaultService';

export default class AssPlanoSafraPropriedadeService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	findAll(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/agro-planosafra/propriedade.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findNaoAssociados(column, order, page, limit, idagroplanosafra, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/agro-planosafra/propriedade/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idagroplanosafra=${idagroplanosafra}&param=${params}`), this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
      }

	findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/agro/agro-planosafra/propriedade/{id}.json?param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
		});
	}

	find(id) {
		return this._http.get(`${this._env}/agro/agro-planosafra/propriedade/${id}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
	}

	save(form) {
		return this._http.post(`${this._env}/agro/agro-planosafra/propriedade`, form, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  updateSituacao(uuid) {
    return this._http.get(`${this._env}/agro/agro-planosafra/propriedade/updatesituacao/${uuid}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  listAll(limit = 50, idcliente, situacao = 1, ...params) {
    return this._http.get(encodeURI(`${this._env}/agro/propriedade/listbyunidademedida.json?limit=${limit}&idcliente=${idcliente}&param=${params}&situacao=${situacao}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

}